<section class="editor-panel">

  <!-- Button Variant -->
  <div class="editor-section">
    <p class="prop-label">Button Variant</p>
    <div class="pills mt-8">
      <div class="pill-left" (click)="setVariant('Solid')" [ngClass]="{'pill-active': buttonStyle.type === 'Solid'}">Solid</div>
      <div class="pill-mid" (click)="setVariant('Outline')" [ngClass]="{'pill-active': buttonStyle.type === 'Outline'}">Outline</div>
      <div class="pill-right" (click)="setVariant('Text')" [ngClass]="{'pill-active': buttonStyle.type === 'Text'}">Text</div>
    </div>
  </div>

  <!-- Background / Fill -->
  <div class="editor-section" *ngIf="buttonStyle.type !== 'Text'">
    <p class="prop-label">Background / Fill</p>
    <div class="color-row mt-8">
      <input type="color" class="color-swatch" [(ngModel)]="buttonStyle.background" (ngModelChange)="emitChange()">
      <input type="text" class="color-code-input" [(ngModel)]="buttonStyle.background" (ngModelChange)="emitChange()">
      <input type="number" class="opacity-input" [(ngModel)]="bs.backgroundOpacity" min="0" max="100" (ngModelChange)="emitChange()">
      <span class="opacity-pct">%</span>
    </div>
  </div>

  <!-- Text Color -->
  <div class="editor-section">
    <p class="prop-label">Text Color</p>
    <div class="color-row mt-8">
      <input type="color" class="color-swatch" [(ngModel)]="buttonStyle.textColor" (ngModelChange)="emitChange()">
      <input type="text" class="color-code-input" [(ngModel)]="buttonStyle.textColor" (ngModelChange)="emitChange()">
      <input type="number" class="opacity-input" [(ngModel)]="bs.textColorOpacity" min="0" max="100" (ngModelChange)="emitChange()">
      <span class="opacity-pct">%</span>
    </div>
  </div>

  <!-- Border Color -->
  <div class="editor-section" *ngIf="buttonStyle.type === 'Outline'">
    <p class="prop-label">Border Color</p>
    <div class="color-row mt-8">
      <input type="color" class="color-swatch" [(ngModel)]="bs.borderColor" (ngModelChange)="emitChange()">
      <input type="text" class="color-code-input" [(ngModel)]="bs.borderColor" (ngModelChange)="emitChange()">
      <input type="number" class="opacity-input" [(ngModel)]="bs.borderColorOpacity" min="0" max="100" (ngModelChange)="emitChange()">
      <span class="opacity-pct">%</span>
    </div>
  </div>

  <!-- Corner Radius -->
  <div class="editor-section">
    <div class="prop-row">
      <p class="prop-label mb-0">Corner Radius</p>
      <div class="corner-row">
        <input type="number" class="px-input" [(ngModel)]="bs.cornerRadius" min="0" max="100" (ngModelChange)="emitChange()">
        <span class="px-label">px</span>
      </div>
    </div>
  </div>

  <!-- Padding -->
  <div class="editor-section">
    <p class="prop-label">Padding</p>
    <div class="padding-grid mt-8">
      <div class="pad-cell">
        <span class="pad-label">Top</span>
        <div class="px-field">
          <input type="number" class="px-input" [(ngModel)]="bs.padding.top" min="0" (ngModelChange)="emitChange()">
          <span class="px-label">px</span>
        </div>
      </div>
      <div class="pad-cell">
        <span class="pad-label">Right</span>
        <div class="px-field">
          <input type="number" class="px-input" [(ngModel)]="bs.padding.right" min="0" (ngModelChange)="emitChange()">
          <span class="px-label">px</span>
        </div>
      </div>
      <div class="pad-cell">
        <span class="pad-label">Bottom</span>
        <div class="px-field">
          <input type="number" class="px-input" [(ngModel)]="bs.padding.bottom" min="0" (ngModelChange)="emitChange()">
          <span class="px-label">px</span>
        </div>
      </div>
      <div class="pad-cell">
        <span class="pad-label">Left</span>
        <div class="px-field">
          <input type="number" class="px-input" [(ngModel)]="bs.padding.left" min="0" (ngModelChange)="emitChange()">
          <span class="px-label">px</span>
        </div>
      </div>
    </div>
  </div>

</section>